import type { AdminRealm } from '@/lib/adminAuth';

// The admin surfaces share the exact same page components. This helper lets
// those shared components figure out which surface (base path) they are being
// rendered under so navigation stays inside the correct admin.
//
//   /albaniaadmin/* -> Albania realm (Zera Travel)
//   /romaniaadmin/* -> Romania realm (Zera Travel)
//   /socialschool/* -> Lewith & Freeman Real Estate (white-label)

export type AdminBase = '/albaniaadmin' | '/romaniaadmin' | '/socialschool';

export function getAdminBase(pathname: string): AdminBase {
  if (pathname.startsWith('/socialschool')) return '/socialschool';
  return pathname.startsWith('/romaniaadmin') ? '/romaniaadmin' : '/albaniaadmin';
}

export function realmForBase(base: AdminBase): AdminRealm {
  if (base === '/socialschool') return 'lewith';
  return base === '/romaniaadmin' ? 'romania' : 'albania';
}

export function baseForRealm(realm: AdminRealm): AdminBase {
  if (realm === 'lewith') return '/socialschool';
  return realm === 'romania' ? '/romaniaadmin' : '/albaniaadmin';
}
